module.exports = __webpack_public_path__ + "img/brentwood.be3b1a7a.jpg";